export default __webpack_public_path__ + "static/media/dices.3d9cee4a.svg";